import React from 'react';
import SpinnerLoader from './../spinnerLoader/spinnerLoader';
import { Link } from 'react-router-dom';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import GuitarChord from 'react-guitar-chords';
import IsScrolling from 'react-is-scrolling';

import './css/index.scss';

const speeds = {
  '20': '9',
  '25': '8',
  '30': '7',
  '35': '6',
  '40': '5',
  '45': '4',
  '50': '3',
  '55': '2',
  '60': '1',
}

class Tab extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      tabId: null,
      autoscroll: false,
      speed: 40
    };
    this.timeout = null;
  }

  componentDidMount(){
      this.setState({tabId: this.props.match.params.id}, () => {
        this.props.getTab(this.props.match.params.id);
      });
      this.timeout = setTimeout(this.incrementScroll, this.state.speed);
  }

  incrementScroll = (to) => {
    if(this.state.autoscroll === true)
    {
      window.scrollBy({
        top: 1,
        // behavior: 'smooth'
      });
    }
    this.timeout = setTimeout(this.incrementScroll, this.state.speed);
  }

  increaseSpeed = () => {
    if(this.state.speed > 20 )
    {
      let newSpeed = this.state.speed - 5;
      this.setState({speed: newSpeed});
    }
  }

  decreaseSpeed = () => {
    
    if(this.state.speed < 60)
    {
      let newSpeed = this.state.speed + 5;
      this.setState({speed: newSpeed});
    }
  }

  componentDidUpdate(){
      if(this.props.tab !== null)
      {
            document.title = "Taburi.ro - " + this.props.tab.artist.name + " - " + this.props.tab.title;
      }
      if(this.props.match.params.id !== this.state.tabId)
      {
        this.setState({tabId: this.props.match.params.id}, () => {
          this.props.getTab(this.props.match.params.id);
        });
      }
  }

  componentWillUnmount(){
      clearTimeout(this.timeout);
      this.timeout = null;
      this.props.clearTab();
  }

  getChord = (chord) => {
    switch(chord){
      // Major Chords
      case 'C':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 3, 2, 0, 1, 0]}
          fingering={[0, 3, 2, 0, 1, 0]}
        />);
      case 'D':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 'x', 0, 2, 3, 2]}
          fingering={[0, 0, 0, 1, 3, 2]}
        />);
      case 'E':
        return (<GuitarChord
          chordName={chord}
          frets={[0, 2, 2, 1, 0, 0]}
          fingering={[0, 2, 3, 1, 0, 0]}
        />);
      case 'F':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 3, 3, 2, 1, 1]}
          fingering={[0, 3, 4, 2, 1, 1]}
        />);  
      case 'G':
        return (<GuitarChord
          chordName={chord}
          frets={[3, 2, 0, 0, 0, 3]}
          fingering={[2, 1, 'x', 'x', 'x', 3]}
        />);  
      case 'A':
        return (<GuitarChord
          chordName={chord}
          frets={[0, 0, 2, 2, 2, 0]}
          fingering={[0, 0, 2, 1, 3, 0]}
        />);  
      case 'B':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 'x', 4, 4, 4, 2]}
          fingering={[0, 0, 2, 3, 4, 1]}
        />);
      // Minor Chords  
      case 'Cm':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 3, 5, 5, 4, 3]}
          fingering={[0, 1, 3, 4, 2, 1]}
        />);
      case 'Dm':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 'x', 0, 2, 3, 1]}
          fingering={[0, 0, 0, 2, 3, 1]}
        />);
      case 'Em':
        return (<GuitarChord
          chordName={chord}
          frets={[0, 2, 2, 0, 0, 0]}
          fingering={[0, 2, 3, 0, 0, 0]}
        />);
      case 'Fm':
        return (<GuitarChord
          chordName={chord}
          frets={[1, 3, 3, 1, 1, 1]}
          fingering={[1, 3, 4, 1, 1, 1]}
        />);  
      case 'Gm':
        return (<GuitarChord
          chordName={chord}
          frets={[3, 5, 5, 3, 3, 3]}
          fingering={[1, 3, 4, 1, 1, 1]}
        />);  
      case 'Am':
        return (<GuitarChord
          chordName={chord}
          frets={[0, 0, 2, 2, 1, 0]}
          fingering={[0, 0, 2, 3, 1, 0]}
        />);  
      case 'Bm':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 2, 4, 4, 3, 2]}
          fingering={[0, 1, 3, 4, 2, 1]}
        />); 
      // Sharp Chords
      
      case 'F#':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 4, 4, 3, 2, 2]}
          fingering={[0, 3, 4, 2, 1, 1]}
        />);
      case 'A7':
        return (<GuitarChord
          chordName={chord}
          frets={[0, 0, 2, 0, 2, 0]}
          fingering={[0, 0, 2, 0, 3, 0]}
        />);    
      case 'B7':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 2, 4, 2, 4, 2]}
          fingering={[0, 1, 3, 1, 4, 1]}
        />);              
      // Other Chords  
      case 'Bb':
        return (<GuitarChord
          chordName={chord}
          frets={['x', 1, 3, 3, 3, 1]}
          fingering={[0, 1, 2, 3, 4, 1]}
        />);        
      default:
      return null;    
    }
  }

  fretify = () => {

    if(this.props.tab === null)
    {
        return <SpinnerLoader />;
    }
    let lines = null;
    let segments = null;
    if(this.props.tab.body_rendered !== null)
    {
      lines = this.props.tab.body_rendered.split(/\r?\n/);
      segments  = lines.map((segment, index) => {
        if(segment.indexOf("((") !== -1)
        {
          // has chords
          let split = segment.split(/(\({2}.*?\){2})/);
          segment = split.map((split_item, index) => {
            if(split_item.indexOf("((") !== -1)
            {
              let chord = split_item.replace(/\({2}(.*?)\){2}/gm, "$1");
              let finalChord = <div style={{color: '#fff'}}>{this.getChord(chord)}</div>;
              return (<Tooltip
                  mouseEnterDelay={0}
                  mouseLeaveDelay={0.1}
                  trigger="hover"
                  overlay={<span>{finalChord}</span>}
                  placement="right"
                  key={`${segment}_${index}`}
                > 
                  <a style={{fontWeight: 'bold', color:'#007bd9', position: 'relative'}} href="#"><span style={{position: 'absolute', top: '-32px'}}>{chord}</span></a>
              </Tooltip>);
            }
            else
            {
              return (<span key={`sx_`+index}>{split_item}</span>);
            }
          });
        }
        if(segment === ' ')
        {
          return <div key={`seg_`+index} style={{ marginTop: "0", lineHeight: '2px'}}></div>;// + "\r\n";
        }
        return <div key={`seg_`+index} style={{ marginTop: "0", lineHeight: '44px'}}>{segment}&nbsp;</div>;// + "\r\n";
      });
    }
    else
    {
      lines = this.props.tab.body.split(/(\({2}.*?\){2})/);
      segments  = lines.map((segment, index) => {
          if(segment.substring(0, 2) === '((')
          {
            let chord = segment.replace(/\({2}(.*?)\){2}/gm, "$1");
  
            let finalChord = <div style={{color: '#fff'}}>{this.getChord(chord)}</div>;
  
            return (<Tooltip
                mouseEnterDelay={0}
                mouseLeaveDelay={0.1}
                trigger="hover"
                overlay={<span>{finalChord}</span>}
                placement="top"
                key={`${segment}_${index}`}
              > 
                <a style={{fontWeight: 'bold', color:'#007bd9'}} href="#">{chord}</a>
            </Tooltip>);
          }
          else
          {
            return segment;
          }
      });
    }
    let content = (
      <div>
          <h1><Link className="regularLink" to={`/artist/${this.props.tab.artist.slug}`}>{this.props.tab.artist.name}</Link> - {this.props.tab.title} </h1>
          <div style={{ fontFamily: 'Menlo', whiteSpace: 'pre-wrap', lineHeight: '24px' }}>
              {segments}
          </div>
      </div>
    ); 
    return content;
  }

  handleAutoscrollChange = () => {
    this.setState({
      autoscroll: !this.state.autoscroll
    });
  }

  render () {
    // console.log('state', this.state, 'interval', this.interval)
    if(this.props.tab !== null && this.props.tab.success !== undefined && this.props.tab.success === false)
    {
        window.location = '/';
    }
    
    return (
      <div className="tabContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-400px'}}>
            <div className="toolBar">
              <div className="toolBar--content">
                <label htmlFor="autoscroll">Autoscroll</label> <input checked={this.state.autoscroll} onChange={this.handleAutoscrollChange} type="checkbox" id="autoscroll" />
                <div>
                  <button className="asButton" onClick={this.decreaseSpeed}>-</button>
                  <button className="asButton" onClick={this.increaseSpeed}>+</button>
                  <div>Viteza: {speeds[this.state.speed]}/9</div>
                </div>
              </div>
            </div>
            {this.fretify()}
          </div>
        </div>
      </div>
    );
  } 
}

export default IsScrolling(Tab);



// WEBPACK FOOTER //
// ./src/components/tab/tab.js